<app-upgrade-overlay *ngIf="dashboard && !m_isHostLocal"></app-upgrade-overlay>
<div style="position: relative; height: 100%;">
    <div class="pageWrapper" fxFlex="100%" fxLayout="column">
        <div class="pageHeader" style="padding-right: 70px;">
            @if (!isMonitorView && !dashboard) {
                <div class="button-group">
                    <button mat-button class="register-button" (click)="showAddPlayerModal()">
                        <mat-icon>queue_play_next</mat-icon>
                        {{'general.registerPlayer' | transloco}}
                    </button>
                    <button (click)="onToggleMinimize()" mat-icon-button class="toggle-panel-button">
                        <mat-icon [class.flipped]="isMinimized">build_circle</mat-icon>
                    </button>
                </div>
            }

            @if (dashboard || experienceLevel > experienceLevelType.BEGINNER) {
                <mat-form-field class="global-filter" style="padding-left: 30px">
                    <mat-label>{{ 'placeholder.filterList' | transloco }}</mat-label>
                    <input matInput inputrestriction="basic1" type="text" (keydown.control.a)="masterToggle()" (keyup)="applyFilter($event.target['value'])" name="SearchDualList" class="form-control" [(ngModel)]="globalFilter" autocomplete="off"/>
                    <a matSuffix aria-label="Clear" (click)="applyFilter('')">
                        <mat-icon>close</mat-icon>
                    </a>
                </mat-form-field>
                <button matTooltip="{{'general.refresh' | transloco}}" spinning (click)="pollStationsHard(); pingSockets()" mat-button>
                    <mat-icon class="spinning">autorenew</mat-icon>
                </button>


                @if (debugMode) {
                    <button matTooltip="start all players" (click)="devModeCommandAll('start')" mat-button>
                        <mat-icon>subscriptions</mat-icon>
                    </button>
                    <button matTooltip="stop all players" (click)="devModeCommandAll('stop')" mat-button>
                        <mat-icon>pan_tool</mat-icon>
                    </button>
                }

                <button *ngIf="!isMonitorView && !dashboard" matTooltip="{{'general.monitor' | transloco}}" (click)="monitorStations()" mat-button>
                    <mat-icon>notifications_none</mat-icon>
                </button>
                <button *ngIf="isMonitorView" matTooltip="{{'general.fullScreen' | transloco}}" (click)="goFullScreen()" mat-button>
                    <mat-icon>fullscreen</mat-icon>
                </button>
                <div style="display: inline-block">
                    <app-video-link *ngIf="isMonitorView" style="position: relative" videoLink="/help/monitor"></app-video-link>
                </div>

                @if (isMonitorView) {
                    <mat-form-field class="form-element" style="margin-right: 10px;">
                        <mat-label>{{ 'general.monitorUrl' | transloco }}</mat-label>
                        <input matInput [(ngModel)]="monitorUrl" inputrestriction="basic1" type="text" class="form-control" (blur)="changeMonitorUrl($event)" (change)="changeMonitorUrl($event)"/>
                        <a matSuffix aria-label="Clear" (click)="changeMonitorUrl('')">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                    <button matTooltip="{{'general.sampleServerCode' | transloco}}" (click)="openEmbedded()" mat-button>
                        <mat-icon>code</mat-icon>
                    </button>
                }
                @if (dashboard) {
                    <div class="radio-group-wrapper hide-lt-md">
                        <div class="toolbar-radio-group v-right-bar" style="display: inline-block; margin-left: 20px;">
                            <mat-radio-group (change)="onPlayerType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group">
                                <mat-radio-button class="example-radio-button" value="0" [checked]="activeVersion == '0'">
                                    <span style="padding-right: 10px">all</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="1" [checked]="activeVersion == '1'">
                                    <span style="padding-right: 10px">legacy</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="2" [checked]="activeVersion == '2'">
                                    <span style="padding-right: 10px">pwa</span>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="toolbar-radio-group" style="display: inline-block;">
                            <mat-radio-group [disabled]="radioDisableButtons" (change)="onConnectionType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group">
                                <mat-radio-button class="example-radio-button" value="0" [checked]="m_EnumConnectionSelected == '0'">
                                    <span style="padding-right: 10px">all</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="1" [checked]="m_EnumConnectionSelected == '1'">
                                    <span style="padding-right: 10px">connected</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="2" [checked]="m_EnumConnectionSelected == '2'">
                                    <span style="padding-right: 10px">disconnected</span>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="option-group-wrapper hide-gt-sm">
                        <mat-form-field style="width: 130px; margin-left: 20px;">
                            <mat-select [(value)]="activeVersion" (selectionChange)="onPlayerType($event)">
                                <mat-option value="0">all</mat-option>
                                <mat-option value="1">legacy</mat-option>
                                <mat-option value="2">pwa</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width: 130px; margin-left: 15px; margin-right: 40px;">
                            <mat-select [(value)]="m_EnumConnectionSelected" (selectionChange)="onConnectionType($event)">
                                <mat-option value="0">all</mat-option>
                                <mat-option value="1">connected</mat-option>
                                <mat-option value="2">disconnected</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                }

                <div style="position: absolute; right: 10px; top: 18px" class="d-flex-center">
                    @if (!isMonitorView && !dashboard) {
                        <button mat-icon-button (click)="filterExpanded = !filterExpanded" class="mini-button" [matTooltip]="filterExpanded ? 'collapse filter' : 'expand filter'">
                            <mat-icon>tune</mat-icon>
                        </button>
                    }
                    @if (!isMonitorView) {
                        <button mat-icon-button style="display: none;" (click)="toggleMinimize.emit();" class="mini-button sidebar-icon">
                            <mat-icon>settings</mat-icon>
                        </button>
                    }
                </div>
                <a *ngIf="!setLargeView && !isMonitorView" style="position: absolute; right: 3px; top: 10px" (click)="onOpenDialog()" mat-button matTooltip="{{'general.screenSettings' | transloco}}">
                    <i *ngIf="selection.selected.length === 0" [ngClass]="{disabled: selection.selected.length === 0}">
                        <fa-icon class="faCogs" [icon]="faCog"></fa-icon>
                    </i>
                    <i *ngIf="selection.selected.length === 1">
                        <fa-icon class="faCogs" [icon]="faCog"></fa-icon>
                    </i>
                    <i *ngIf="selection.selected.length > 1">
                        <fa-icon class="faCogs" [icon]="faCogs"></fa-icon>
                    </i>
                </a>
            }
            <app-video-link videoLink="players" style="display: inline-block;"></app-video-link>
        </div>

        @if (!dashboard && experienceLevel > experienceLevelType.BEGINNER) {
            <div class="advancedFilters" [ngClass]="{'collapsed': !filterExpanded}">
                <div class="d-flex-center" style="margin: 5px;">
                    <div class="radio-group-wrapper hide-lt-md">
                        <div class="toolbar-radio-group v-right-bar" style="display: inline-block;">
                            <mat-radio-group (change)="onPlayerType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group">
                                <mat-radio-button class="example-radio-button" value="0" [checked]="activeVersion == '0'">
                                    <span style="padding-right: 10px">all</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="1" [checked]="activeVersion == '1'">
                                    <span style="padding-right: 10px">legacy</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="2" [checked]="activeVersion == '2'">
                                    <span style="padding-right: 10px">pwa</span>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="toolbar-radio-group v-right-bar" style="display: inline-block;">
                            <mat-radio-group [disabled]="radioDisableButtons" (change)="onConnectionType($event)" aria-labelledby="example-radio-group-label" class="example-radio-group">
                                <mat-radio-button class="example-radio-button" value="0" [checked]="m_EnumConnectionSelected == '0'">
                                    <span style="padding-right: 10px">all</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="1" [checked]="m_EnumConnectionSelected == '1'">
                                    <span style="padding-right: 10px">connected</span>
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" value="2" [checked]="m_EnumConnectionSelected == '2'">
                                    <span style="padding-right: 10px">disconnected</span>
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="option-group-wrapper hide-gt-sm">
                        <mat-form-field style="width: 130px;">
                            <mat-select [(value)]="activeVersion" (selectionChange)="onPlayerType($event)">
                                <mat-option value="0">all</mat-option>
                                <mat-option value="1">legacy</mat-option>
                                <mat-option value="2">pwa</mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field style="width: 130px; margin-left: 15px; margin-right: 40px;">
                            <mat-select [(value)]="m_EnumConnectionSelected" (selectionChange)="onConnectionType($event)">
                                <mat-option value="0">all</mat-option>
                                <mat-option value="1">connected</mat-option>
                                <mat-option value="2">disconnected</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="d-flex-center" style="margin: 5px;">
                    <mat-form-field style="width: 150px; margin-right: 20px;" class="category-wrapper">
                        <mat-select placeholder="{{'placeholder.filterCategory' | transloco}}" [(value)]="categorySelected" (selectionChange)="filteryByCategory($event)">
                            <mat-option>{{ 'general.noCategory' | transloco }}</mat-option>
                            <mat-option *ngFor="let category of categories" [value]="category">
                                {{ category }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <app-scene-selector [setMode]="'SCENE:PLAYER_ASSIGNABLE'" [previewMode]="false" [includeLibrary]="false" (changeSelectedScene)="filterByScene($event)"></app-scene-selector>
                </div>
            </div>
        }
        <div class="tableWrapper" *ngIf="dataSource && !pageLoading">
            <ng-container *ngIf="!isMonitorView; else monitorView">
                <table mat-table [dataSource]="dataSource" [trackBy]="m_trackBy" multiple="false" matSort class="mat-elevation-z8" [@staggerAnimation]>
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox *ngIf="allowMultiSelect"
                                          (change)="$event ? masterToggle() : null"
                                          [checked]="selection.hasValue() && isAllSelected()"
                                          [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                          (change)="$event ? selection.toggle(row.stat['$']['station_business_id']) : null"
                                          [checked]="selection.isSelected(row.stat['$']['station_business_id'])">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th style="width: 50px" mat-header-cell *matHeaderCellDef> {{ 'general.status' | transloco }}</th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="dashboard">
                                <div *ngIf="element.stat['$']['version'] == 2" style="text-align: center">
                                    <mat-icon (click)="openStatisticModal(element)" class="station-poll statusScreenIcon" *ngIf="element.stat['$']['connection'] == 2" inline="true" svgIcon="">play_circle</mat-icon>
                                    <mat-icon (click)="openStatisticModal(element)" class="station-up statusScreenIcon" *ngIf="element.stat['$']['connection'] == 1 && element.stat['$']['playing'] == '1'" inline="true" svgIcon="">play_circle</mat-icon>
                                    <mat-icon (click)="openStatisticModal(element)" class="station-up statusScreenIcon" *ngIf="element.stat['$']['connection'] == 1 && element.stat['$']['playing'] == '0'" inline="true" svgIcon="">stop_circle</mat-icon>
                                    <mat-icon class="station-down statusScreenIcon" *ngIf="element.stat['$']['connection'] == 0" inline="true" svgIcon="">cancel</mat-icon>
                                </div>
                                <div *ngIf="element.stat['$']['version'] != 2" style="text-align: center">
                                    <mat-icon (click)="openStatisticModal(element)" class="station-poll statusScreenIcon" *ngIf="element.stat['$']['connection'] == 2" inline="true" svgIcon="">live_tv</mat-icon>
                                    <mat-icon (click)="openStatisticModal(element)" class="station-up statusScreenIcon" *ngIf="element.stat['$']['connection'] == 1" inline="true" svgIcon="">live_tv</mat-icon>
                                    <mat-icon class="station-down statusScreenIcon" *ngIf="element.stat['$']['connection'] == 0" inline="true" svgIcon="">tv_off</mat-icon>
                                </div>
                            </div>
                            <div>
                                <div *ngIf="!dashboard">
                                    <div *ngIf="element.props.version == 2" style="text-align: center">
                                        <mat-icon (click)="openStatisticModal(element)" class="station-poll statusScreenIcon" *ngIf="element.stat['$']['connection'] == 2" inline="true" svgIcon="">play_circle</mat-icon>
                                        <mat-icon (click)="openStatisticModal(element)" class="station-up statusScreenIcon" *ngIf="element.stat['$']['connection'] == 1 && element.stat['$']['playing'] == '1'" inline="true" svgIcon="">play_circle</mat-icon>
                                        <mat-icon (click)="openStatisticModal(element)" class="station-up statusScreenIcon" *ngIf="element.stat['$']['connection'] == 1 && element.stat['$']['playing'] == '0'" inline="true" svgIcon="">stop_circle</mat-icon>
                                        <mat-icon class="station-down statusScreenIcon" *ngIf="element.stat['$']['connection'] == 0" inline="true" svgIcon="">cancel</mat-icon>
                                    </div>
                                    <div *ngIf="element.props.version != 2" style="text-align: center">
                                        <mat-icon (click)="openStatisticModal(element)" class="station-poll statusScreenIcon" *ngIf="element.stat['$']['connection'] == 2" inline="true" svgIcon="">live_tv</mat-icon>
                                        <mat-icon (click)="openStatisticModal(element)" class="station-up statusScreenIcon" *ngIf="element.stat['$']['connection'] == 1" inline="true" svgIcon="">live_tv</mat-icon>
                                        <mat-icon class="station-down statusScreenIcon" *ngIf="element.stat['$']['connection'] == 0" inline="true" svgIcon="">tv_off</mat-icon>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="watchDogConnection">
                        <th style="width: 50px" mat-header-cell *matHeaderCellDef>{{ 'general.watchdog' | transloco }}</th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="dashboard">
                                <div *ngIf="element.stat['$']['version'] == 2" style="text-align: center">
                                    <mat-icon class="station-down statusScreenIcon" *ngIf="element.stat['$']['wdConnected'] == 0" inline="true" svgIcon="">remove_moderator</mat-icon>
                                    <mat-icon class="station-up statusScreenIcon" *ngIf="element.stat['$']['wdConnected'] == 1" inline="true" svgIcon="">verified_user</mat-icon>
                                </div>
                                <div *ngIf="element.stat['$']['version'] != 2" style="text-align: center">
                                    <mat-icon class="station-down statusScreenIcon" *ngIf="element.stat['$']['socket'] == 0" inline="true" svgIcon="">remove_moderator</mat-icon>
                                    <mat-icon class="station-up statusScreenIcon" *ngIf="element.stat['$']['socket'] == 1" inline="true" svgIcon="">security</mat-icon>
                                </div>
                            </div>
                            <div *ngIf="!dashboard">
                                <div *ngIf="element.props.version == 2" style="text-align: center">
                                    <mat-icon class="station-up statusScreenIcon" *ngIf="element.stat['$']['wdConnected'] == 1 ;else noWd" inline="true" svgIcon="">verified_user</mat-icon>
                                    <ng-template #noWd>
                                        <mat-icon (click)="onOpenDialogNoWatchdog()" class="noWatchdog station-poll statusScreenIcon" inline="true" svgIcon="">info</mat-icon>
                                    </ng-template>
                                </div>
                                <div *ngIf="element.props.version != 2" style="text-align: center">
                                    <mat-icon class="station-down statusScreenIcon" *ngIf="element.stat['$']['socket'] == 0" inline="true" svgIcon="">remove_moderator</mat-icon>
                                    <mat-icon class="station-up statusScreenIcon" *ngIf="element.stat['$']['socket'] == 1" inline="true" svgIcon="">security</mat-icon>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="version">
                        <th style="width: 50px" mat-header-cell mat-sort-header *matHeaderCellDef>PWA</th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="dashboard">
                                <div *ngIf="element.stat['$']['version'] == 2" style="text-align: center">
                                    <mat-icon>add_task</mat-icon>
                                </div>
                                <div *ngIf="element.stat['$']['version'] != 2" style="text-align: center">
                                    <mat-icon class="disabled">block</mat-icon>
                                </div>
                            </div>
                            <div *ngIf="!dashboard">
                                <div *ngIf="element.props.version == 2" style="text-align: center">
                                    <mat-icon>add_task</mat-icon>
                                </div>
                                <div *ngIf="element.props.version != 2" style="text-align: center">
                                    <mat-icon class="disabled">block</mat-icon>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>{{ 'general.name' | transloco }}</th>
                        <td mat-cell *matCellDef="let element"> {{ element.props.station_name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="category">
                        <th mat-header-cell [resizeColumn]="true" *matHeaderCellDef> {{ 'general.category' | transloco }}</th>
                        <td mat-cell *matCellDef="let element"> {{ element.props['tree_path'] }}</td>
                    </ng-container>

                    <ng-container *ngIf="dashboard" matColumnDef="businessId">
                        <th mat-header-cell mat-sort-header [resizeColumn]="true" *matHeaderCellDef> {{ 'general.business' | transloco }}</th>
                        <td mat-cell *matCellDef="let element"> {{ element.stat['$']['businessId'] | StringJSV2Pipe:stringJSPipeClean }}</td>
                    </ng-container>

                    <ng-container matColumnDef="startTime">
                        <th style="width: 150px" mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.startTime' | transloco }}</th>
                        <td mat-cell *matCellDef="let element"> {{ element.stat['$']['startTime'] }}</td>
                    </ng-container>

                    <ng-container matColumnDef="playing">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.playing' | transloco }}</th>
                        <td mat-cell *matCellDef="let element"> {{ element.stat['$']?.playing }}</td>
                    </ng-container>

                    <!-- Weight Column -->
                    <!--                        <ng-container matColumnDef="lastUpdate">-->
                    <!--                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'general.lastUpdate' | transloco}}</th>-->
                    <!--                            <td mat-cell *matCellDef="let element"> {{element.stat['$']['lastUpdate']}} </td>-->
                    <!--                        </ng-container>-->

                    <!--                        <ng-container matColumnDef="IP">-->
                    <!--                            <th mat-header-cell mat-sort-header *matHeaderCellDef> IP</th>-->
                    <!--                            <td mat-cell *matCellDef="let element"> {{element.stat['$']['geoLocation']?.ip}} </td>-->
                    <!--                        </ng-container>-->

                    <ng-container matColumnDef="appVersion">
                        <th style="width: 100px" mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'general.version' | transloco }}</th>
                        <td mat-cell *matCellDef="let element"> {{ element.stat['$']['appVersion'] }}</td>
                    </ng-container>

                    <!--                        <ng-container matColumnDef="totalMemory">-->
                    <!--                            <th mat-header-cell mat-sort-header *matHeaderCellDef>{{'general.totalMemory' | transloco}}</th>-->
                    <!--                            <td mat-cell *matCellDef="let element"> {{element.stat['$']['totalMemory']}} </td>-->
                    <!--                        </ng-container>-->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </ng-container>
            <ng-template #monitorView>
                <div fxLayout="row wrap" fxLayoutAlign="flex-start" class="flex-xs-center-center flex-xs-col" style="margin: 10px;" [@staggerAnimation]>
                    <ng-container *ngFor="let station of dataSourceList$ | async">
                        <div *ngIf="station.stat?.$?.station_business_id as _stationId" fxLayout="column" class="station-tile"
                             [ngClass]="{
                                'tile-station-poll': station.stat['$']['connection'] == 2,
                                'tile-station-up': station.stat['$']['connection'] == 1,
                                'tile-station-down': station.stat['$']['connection'] == 0,
                            }">

                            <div class="tile-name">
                                <div class="tile-name-no-chart" fxLayout="row" fxLayoutAlign="center center"
                                     [ngClass]="{'hide': monitorPlayers[_stationId] && monitorPlayers[_stationId].showChart}">
                                    <span style="color: black">{{ station.props.station_name }}</span>
                                </div>
                                <div class="tile-chart" *ngIf="monitorPlayers[_stationId] && monitorPlayers[_stationId].showChart">
                                    <app-bar-chart [results]="monitorPlayers[_stationId].data"></app-bar-chart>
                                </div>
                            </div>
                            <div class="tile-start">
                                start: {{ station.stat['$']['startTime'] }} | version: {{ station.stat['$']['appVersion'] }}
                            </div>
                            <div class="tile-status" fxLayout="row" fxLayoutAlign="space-between center">
                                <div class="icons d-flex-center">
                                    <div class="icon-status">
                                        <div *ngIf="station.props.version == 2">
                                            <mat-icon class="station-poll statusScreenIcon" *ngIf="station.stat['$']['connection'] == 2" inline="true" svgIcon="">play_circle</mat-icon>
                                            <mat-icon class="station-up statusScreenIcon" *ngIf="station.stat['$']['connection'] == 1 && station.stat['$']['playing'] == '1'" inline="true" svgIcon="">play_circle</mat-icon>
                                            <mat-icon class="station-up statusScreenIcon" *ngIf="station.stat['$']['connection'] == 1 && station.stat['$']['playing'] == '0'" inline="true" svgIcon="">stop_circle</mat-icon>
                                            <mat-icon class="station-down statusScreenIcon" *ngIf="station.stat['$']['connection'] == 0" inline="true" svgIcon="">cancel</mat-icon>
                                        </div>
                                        <div *ngIf="station.props.version != 2">
                                            <mat-icon class="station-poll statusScreenIcon" *ngIf="station.stat['$']['connection'] == 2" inline="true" svgIcon="">live_tv</mat-icon>
                                            <mat-icon class="station-up statusScreenIcon" *ngIf="station.stat['$']['connection'] == 1" inline="true" svgIcon="">live_tv</mat-icon>
                                            <mat-icon class="station-down statusScreenIcon" *ngIf="station.stat['$']['connection'] == 0" inline="true" svgIcon="">tv_off</mat-icon>
                                        </div>
                                    </div>
                                    <div class="icon-watch-dog">
                                        <div *ngIf="station.props.version == 2">
                                            <mat-icon class="station-up statusScreenIcon" *ngIf="station.stat['$']['wdConnected'] == 1 ;else noWd" inline="true" svgIcon="">verified_user</mat-icon>
                                            <ng-template #noWd>
                                                <mat-icon (click)="onOpenDialogNoWatchdog()" class="noWatchdog station-poll statusScreenIcon" inline="true" svgIcon="">info</mat-icon>
                                            </ng-template>
                                        </div>
                                        <div *ngIf="station.props.version != 2">
                                            <mat-icon class="station-down statusScreenIcon" *ngIf="station.stat['$']['socket'] == 0" inline="true" svgIcon="">remove_moderator</mat-icon>
                                            <mat-icon class="station-up statusScreenIcon" *ngIf="station.stat['$']['socket'] == 1" inline="true" svgIcon="">security</mat-icon>
                                        </div>
                                    </div>
                                    <div class="icon-pwa">
                                        <div *ngIf="station.props.version == 2">
                                            <mat-icon>add_task</mat-icon>
                                        </div>
                                        <div *ngIf="station.props.version != 2">
                                            <mat-icon class="disabled">block</mat-icon>
                                        </div>
                                    </div>
                                    <div class="icon-pie">
                                        <mat-icon *ngIf="monitorPlayers[_stationId]" (click)="showMonitorChart(station)" matTooltip="{{'general.showChart' | transloco}}">pie_chart</mat-icon>
                                        <mat-icon *ngIf="!monitorPlayers[_stationId]" class="disabled">pie_chart</mat-icon>
                                    </div>
                                    <div class="icon-statistic">
                                        <mat-icon style="cursor: pointer" matTooltip="{{'general.statistics' | transloco}}" (click)="openStatisticModal(station)">timeline</mat-icon>
                                    </div>
                                </div>
                                <div class="notify-status">
                                    <mat-checkbox [checked]="station.props.send_notification" (change)="changeSendNotification(station, $event.checked)">{{ 'general.monitor' | transloco }}</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

            </ng-template>
        </div>
        <div *ngIf="!dataSource || pageLoading" style="overflow: hidden">
            <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
            <br/>
            <div fxLayout="row" fxLayoutAlign="center center">
                <mat-icon>hourglass_empty</mat-icon>
                {{ 'placeholder.makeTakeMinute' | transloco }} ...
            </div>
            <br/>
            <br/>
        </div>
        <ng-container>
            <mat-paginator customPageSize
                           [pageSize]="pageSize"
                           [pageSizeOptions]="pageSizeOptions"
                           [showFirstLastButtons]="true">
            </mat-paginator>
        </ng-container>
    </div>
</div>

<ng-template let-modal #noWatchdogModal>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <mat-icon class="moveMatIcon">install_desktop</mat-icon>
        <mat-label style="font-size: 1.2em">{{ 'general.installPlayerVideo' | transloco }}</mat-label>
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        {{ 'general.wdNotRunning' | transloco }}
        <br/>
        <br/>
        <div fxLayout="column">
            <div>
                <app-video-link style="display: inline-block;" [videoLink]="'/help/sign_win_install'"></app-video-link>
                {{ 'general.installWindows' | transloco }}
            </div>
            <div>
                <app-video-link style="display: inline-block;" [videoLink]="'/help/sign_android_v11'"></app-video-link>
                {{ 'general.installAndroid' | transloco }}
            </div>
            <div>
                <app-video-link style="display: inline-block;" [videoLink]="'/help/sign_mac_install'"></app-video-link>
                {{ 'general.installMac' | transloco }}
            </div>
            <div>
                <app-video-link style="display: inline-block;" [videoLink]="'/help/ubuntu_install_v3'"></app-video-link>
                {{ 'general.installUbuntu' | transloco }}
            </div>
        </div>
        <br/>
        <br/>
        <br/>
    </div>
</ng-template>
